import { useCallback } from 'react';
import { applicationPaths } from '@core/http/applicationPaths';
import { useApi } from '@core/http/useApi';
import { MainGraphDataModel, SiteActuationsModel, GraphDataGetModel, MainGraphFiltersStateModel } from '@shared/models';
import { formatDateForApi } from '@hwm/ui-lib';

export const useDeviceMainGraphDataSource = (id: number) => {
  const [getGraphData, graphData, graphLoading] = useApi<MainGraphDataModel[]>(
    applicationPaths.pmZones.getMainGraphData({ id }),
    'get'
  );

  const [getActuations, actuationsData, actuationsLoading] = useApi<SiteActuationsModel[]>(
    applicationPaths.sites.getActuations,
    'get'
  );

  const handleGetGraphData = useCallback(
    (params: MainGraphFiltersStateModel) => {
      getGraphData({
        additionalOptions: {
          params: {
            timePeriod: 'Custom',
            interval: params.interval,
            customFrom: formatDateForApi(params.range[0]),
            customTo: formatDateForApi(params.range[1]),
            flowUnit: params.flowUnit,
            pressureUnit: params.pressureUnit,
          } as GraphDataGetModel,
        },
      });
    },
    [getGraphData]
  );

  const handleGetActuations = useCallback(
    (prValveId: number, range: [Date, Date]) => {
      const [from, to] = range;
      getActuations({
        additionalOptions: {
          params: {
            siteIds: [...(prValveId ? [prValveId] : [])],
            from: formatDateForApi(from),
            to: formatDateForApi(to),
          },
          paramsSerializer: (params) => {
            return Object.keys(params)
              .map((paramKey) => {
                if (paramKey === 'siteIds') {
                  return params[paramKey].map((siteId: number) => `${paramKey}=${siteId}`).join('&');
                }
                return `${paramKey}=${params?.[paramKey] ?? ''}`;
              })
              .join('&');
          },
        },
      });
    },
    [getActuations]
  );

  return {
    getGraphData: handleGetGraphData,
    graphData,
    getActuations: handleGetActuations,
    actuationsData,
    loading: graphLoading || actuationsLoading,
  };
};
